<template>
  <HorizontalScrollSection title="Trending Outfit Formulas">
    <template
      v-if="outfitFormulas.length > 0"
      #default>
      <div
        v-for="formula in outfitFormulas"
        :key="formula.id"
        class="col-6 col-md-4 me-sm align-self-center h-100">
        <ClosetOutfitFormulaCard :formula/>
      </div>
    </template>
    <template
      v-else
      #default>
      <div
        v-for="i in 5"
        :key="i"
        class="col-6 col-md-4 me-sm card-placeholder"/>
    </template>
  </HorizontalScrollSection>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useOutfitGeneratorStore } from '@/stores/outfitGenerator'
import ClosetOutfitFormulaCard from '@/components/outfitBuilder/ClosetOutfitFormulaCard.vue'
import HorizontalScrollSection from '@shared/components/ADORN/HorizontalScrollSection.vue'

const outfitGeneratorStore = useOutfitGeneratorStore()
const { outfitFormulas } = storeToRefs(outfitGeneratorStore)

onMounted(async () => {
  await outfitGeneratorStore.fetchOutfitFormulas()
})
</script>
<style scoped lang="scss">
.card-placeholder {
  height: 100%;
  width: 100%;
  background-color: $light-ash;
  @include placeholder-loading-animation;
  @include media-tablet-or-larger {
    aspect-ratio: 300/250;
  }
  @include media-mobile {
    aspect-ratio: 166/260;
  }
}
</style>